import * as requestFromServer from './popupInvoicesListCrud';
import {popupInvoicesListSlice, callTypes} from './popupInvoicesListSlice';

const {actions} = popupInvoicesListSlice;

export const getInvoicesByCustomer = customerID => dispatch => {
  dispatch(actions.startCall({callType: callTypes.data}));

  return requestFromServer
    .getInvoicesByCustomer(customerID)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(actions.popupInvoicesListFetched({
        entities: data
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError({error, callType: callTypes.data}));
    });
};
